var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504.16 672.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f3f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,332.66q0-122,0-244C0,72.42,3,56.84,11.48,42.77,28.09,15.15,52.87.54,84.89.29c68.33-.54,136.66-.12,205-.28,4.44,0,4.21,2.07,4.2,5.1Q294,84.85,294,164.6c0,10.5,1.48,20.52,8.07,29.23,9.15,12.12,21.76,16.29,36.31,16.29,53.33,0,106.66.05,160-.1,4.43,0,5.76.92,5.76,5.62q-.22,184.24-.13,368.48c0,40.56-24.55,74.21-61.36,84.43a93.86,93.86,0,0,1-25.14,3.56q-165.49,0-331,0c-39.92,0-74.4-26.26-83.49-63.23a107.33,107.33,0,0,1-3-25.73Q0,457.91,0,332.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.56,1.36l166.3,166.32c-.84,1.22-2.46.4-3.76.4q-79.19.08-158.37.12c-3.5,0-4.83-.52-4.82-4.51.15-53,.1-105.92.12-158.87C336,3.7,335.61,2.49,336.56,1.36Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.42e9ef1c168b1b771c93fe16d4044f32.svg";
export { ForwardRef as ReactComponent };